
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "app-layout",
  components: {},
  setup() {
    return {
      
    };
  },
});
